

const state = {
	/* url-translation页面 相关 */
	urlTranslation: {
		searchHistory: []
	},
	lanTranslation: {
		editURLSearchHistory: []
	}
}

const mutations = {
	/* url-translation页面 相关 */
	ADD_URLSEARCHHISTORY: (state,value) => {
		const historyArr = state['urlTranslation'].searchHistory
		!historyArr.includes(value.trim()) && historyArr.unshift(value)
	},
	DEL_URLSEARCHHISTORY: (state,index) => {
		state['urlTranslation'].searchHistory.splice(index,1)
	},
	/* language-translation页面 相关 */
	ADD_EDITURLSEARCHHISTORY: (state,value) => {
		const historyArr = state['lanTranslation'].editURLSearchHistory
		!historyArr.includes(value.trim()) && historyArr.unshift(value)
	},
	DEL_EDITURLSEARCHHISTORY: (state,index) => {
		state['lanTranslation'].editURLSearchHistory.splice(index,1)
	},
}

const actions = {
	/* url-translation页面 相关 */
	addSearchHistoryAction({ commit },value) {
		commit('ADD_URLSEARCHHISTORY',value)
	},
	delSearchHistoryAction({ commit },index) {
		commit('DEL_URLSEARCHHISTORY',index)
	},
	/* language-translation页面 相关 */
	addEditUrlSearchHistoryAction({ commit },value) {
		commit('ADD_EDITURLSEARCHHISTORY',value)
	},
	delEditUrlSearchHistoryAction({ commit },index) {
		commit('DEL_EDITURLSEARCHHISTORY',index)
	},
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
